import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { UserPermissions } from 'src/app/permissions';
import { StorageSettings } from 'src/app/utils/storage.settings';
import { AppRoute } from 'src/app/utils/approutes';

@Injectable({
    providedIn: 'root'
})
export class EmployeeRoleGuard implements CanActivate {

  constructor(private localstorageService: LocalstorageService,
    private routerService: Router, private storage: StorageSettings, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    /*
     * TMS-14513 Supplier able to approve/reject proposal
     * Enhance employee validation to prevent suppliers from modifying proposal workflow status.
     */
      const isEmployee = this.localstorageService.retrieve(Constants.localStorageKeys.IsEmployee) === Constants.IsEmployeeCheckCode;
      if (isEmployee) {
        const appRoute = <AppRoute>route.routeConfig;
        return this.verifyAccessGranted(appRoute.Roles);
      } else {
        this.routerService.navigate(['/auth/unauthorized']);
        return false;
      }
  }

  verifyAccessGranted(roles: UserPermissions[]): boolean {
    let readAccessGranted = false;
    let writeAccessGranted = false;

    if (roles != null) {
        let isReadPermission = false;
        let isWritePermission = false;
        roles.forEach(role => {
            isReadPermission = UserPermissions[role].indexOf('Read') >= 0;
            isWritePermission = UserPermissions[role].indexOf('Write') >= 0;
            if (isReadPermission) {
                readAccessGranted = readAccessGranted || this.authService.HasPermission(role);
            } else if (isWritePermission) {
                writeAccessGranted = writeAccessGranted || this.authService.HasPermission(role);
            } else {
                readAccessGranted = true;
                writeAccessGranted = true;
            }
        });
    } else {
        readAccessGranted = true;
        writeAccessGranted = true;
    }

    this.storage.CurrentPageRead = readAccessGranted;
    this.storage.CurrentPageWrite = writeAccessGranted;

    if (readAccessGranted || writeAccessGranted) {
        return true;
    } else {
        this.routerService.navigate(['/auth/unauthorized']);
        return false;
    }
}

}
